// extracted by mini-css-extract-plugin
export default {"container":"chat_container__22Mak","messages":"chat_messages__ECoLn","message":"chat_message__uXNYG","messageInput":"chat_messageInput__n+X29"};